import { Form, Input, ModalProps, FormProps, Modal, InputNumber, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { findProjectFieldName } from 'gql/query'

type CreateSubjectProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const CreateSubject: React.FC<CreateSubjectProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    if (values && values?.name?.trim() && values?.code?.trim()) {
      values.name = values?.name?.trim()
      const isNameRepeated: any = await findProjectFieldName(values.name, 'name', 'subjects')
      if (isNameRepeated && isNameRepeated?.subjects?.length === 0) {
        return (
          formProps.onFinish &&
          formProps.onFinish({
            ...values,
            created_by: user?.id,
          })
        )
      } else {
        message.error("Can't add a subject with repeated name...")
      }
    } else {
      message.error('Expected values are missing...')
    }
  }
  return (
    <Modal {...modalProps} title="Create Subject">
      <Form
        {...formProps}
        size="large"
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              createUserHistory('subjects', 'create', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Subject Code"
          name="code"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Subject Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
